import { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, ArrowRight } from "lucide-react";
import Logo from "@/components/Logo";

const NAV = [
  { to: "/", label: "Beranda" },
  { to: "/layanan", label: "Layanan" },
  { to: "/portfolio", label: "Portfolio" },
  { to: "/tentang", label: "Tentang" },
  { to: "/kontak", label: "Kontak" },
];

const linkBase =
  "text-sm font-semibold tracking-wide uppercase transition-colors";
const linkInactive = "text-[#52525B] hover:text-[#18181B]";
const linkActive = "text-[#DC2626]";

export const Header = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  return (
    <header
      className="sticky top-0 z-50 bg-white/85 backdrop-blur-xl border-b border-[#E4E4E7]"
      data-testid="site-header"
    >
      <div className="kt-container flex items-center justify-between h-20">
        <Link to="/" data-testid="header-home-link">
          <Logo size={42} />
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              data-testid={`nav-${item.label.toLowerCase()}-link`}
              className={({ isActive }) =>
                `${linkBase} ${isActive ? linkActive : linkInactive}`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <Link
            to="/kontak"
            className="kt-btn-primary text-sm"
            data-testid="header-cta-quote-link"
          >
            Minta Penawaran <ArrowRight size={16} />
          </Link>
        </div>

        <button
          className="lg:hidden p-2"
          onClick={() => setOpen((v) => !v)}
          aria-label="menu"
          data-testid="mobile-menu-toggle"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div
          className="lg:hidden border-t border-[#E4E4E7] bg-white"
          data-testid="mobile-menu"
        >
          <div className="kt-container py-4 flex flex-col gap-4">
            {NAV.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                onClick={() => setOpen(false)}
                className={`${linkBase} ${
                  location.pathname === item.to ? linkActive : linkInactive
                }`}
                data-testid={`mobile-nav-${item.label.toLowerCase()}-link`}
              >
                {item.label}
              </Link>
            ))}
            <Link
              to="/kontak"
              className="kt-btn-primary justify-center"
              onClick={() => setOpen(false)}
              data-testid="mobile-cta-quote-link"
            >
              Minta Penawaran <ArrowRight size={16} />
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
